import styles from "./BioEditModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import InputTextArea from "../../../../CommonComponents/InputControls/InputTextArea";

const BioEditModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      const initData = {
        companyDescription: data?.companyDescription,
      };
      setInitialData(initData);
      form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    console.warn("values", values);

    try {
      setLoading(true);
      var payload = {
        _id: data._id,
        companyDescription: values.companyDescription,
      };

      const res = await EnterpriseServices.UpdateEnterprise(payload);

      if (res) {
        if (res.statusCode === 1) {
          onSubmit();
          onCancel(false);
          showNotification("Company biograpgy updated Successfully");
          setLoading(false);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating biography", error);
        handleError(error.description);
      } else {
        handleError("Error: company biography is not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleChange = (key, value) => {
    setInitialData({ ...initialData, [key]: value });
  };

  return (
    <>
      <Modal
        title="Company Biography"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialData}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <InputTextArea
                placeholder="Enter company biography"
                name={"companyDescription"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Company Biography is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default BioEditModal;
